













import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class WebAssistantLauncher extends Vue {
	@Prop() public isOpen: boolean;

	@Prop() public backgroundColour: string;

	@Prop() public iconColour: string;

	public buttonClick() {
		this.$emit('buttonClick');
	}
}
